import { render, staticRenderFns } from "./cards-tables.vue?vue&type=template&id=91b4cb12&scoped=true"
import script from "./cards-tables.vue?vue&type=script&lang=js"
export * from "./cards-tables.vue?vue&type=script&lang=js"
import style0 from "./cards-tables.vue?vue&type=style&index=0&id=91b4cb12&prod&lang=css"
import style1 from "./cards-tables.vue?vue&type=style&index=1&id=91b4cb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b4cb12",
  null
  
)

export default component.exports